@if (error) {
    <small class="color-status-red4">
        An error occurred while loading the discrepancies, please try in some
        time.
    </small>
} @else {
    @if (resultCount) {
        <div
            class="mt-1 mb-1 color-gray18"
            [attr.data-qa]="dataQa.discrepancyViewResultCount">
            <span class="text-s">
                @if (selectedDiscrepancyCount) {
                    <span class="text-semi">
                        {{ selectedDiscrepancyCount }}/</span
                    >{{ resultCount }} Discrepancies Selected
                } @else {
                    {{ resultCount }} Discrepancies
                }
            </span>
        </div>
    }
    <app-table
        noRowsText="No workflow items to show."
        [attr.data-qa]="dataQa.documentViewTable"
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
        [suppressMenu]="true"
        [totalItems]="resultCount"
        (gridReady)="onGridReady($event)" />
}
